// pages/opencheck/checklists.service.js
// 📍 Complete updated file with all necessary changes

import { apiService } from "../../app.service";

export const checkListsApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch a single checklist
    fetchChecklist: builder.query({
      query: ({ id, locationId }) => ({
        url: `/checklist/${id}`,
        params: locationId ? { locationId } : {},
      }),
      providesTags: (result) =>
        result ? [{ type: "Checklist", id: result._id }] : [],
    }),

    // ✅ Fetch all checklists
    fetchChecklists: builder.query({
      query: ({ locationId } = {}) => ({
        url: "/user/checklists",
        params: locationId ? { locationId } : {},
      }),
      providesTags: ["Checklists"],
    }),

    // ✅ Fetch checklists by type (with location support)
    fetchChecklistsByType: builder.query({
      query: ({ type, locationId }) => ({
        url: "/checklist",
        params: { 
          type,
          ...(locationId && { locationId }),
        },
      }),
      providesTags: ["ChecklistsByType"],
    }),

    // ✅ Create a new checklist (location from API)
    createChecklist: builder.mutation({
      query: (data) => ({
        url: "/checklist",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Checklists", "ChecklistsByType"],
    }),

    // ✅ Update an existing checklist (with locationId)
    updateChecklist: builder.mutation({
      query: ({ id, data, locationId }) => ({
        url: `/checklist/${id}`,
        method: "PUT",
        body: {
          ...data,
          ...(locationId && { locationId }), // ✅ PASS LOCATION ID
        },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Checklist", id },
        "ChecklistsByType",
      ],
    }),

    // ✅ Update checklist log
    updateChecklistlog: builder.mutation({
      query: ({ id, status, locationId }) => ({
        url: `/user/checklistlog/${id}`,
        method: "PUT",
        body: { 
          status,
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Checklist", id }],
    }),

    // ✅ Delete a checklist
deleteChecklist: builder.mutation({
  query: ({ id, locationId }) => ({
    url: `/checklist/${id}`,
    method: "DELETE",
    body: locationId ? { locationId } : {}, // ✅ body mein bhejo
  }),
  invalidatesTags: ["Checklists", "ChecklistsByType"],
}),

    // ✅ Reorder tasks (with locationId)
    reorderTasks: builder.mutation({
      query: ({ tasks, locationId }) => ({
        url: `/checklist/reorder-tasks`,
        method: "PUT",
        body: {
          tasks,
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: ["ChecklistsByType"],
    }),

    // ✅ Fetch opening checklist status
    fetchOpenChecklistStatus: builder.query({
      query: ({ locationId } = {}) => ({
        url: `/user/restaurant/open-checklist`,
        params: locationId ? { locationId } : {},
      }),
      providesTags: ["openChecklistStatus"],
    }),

    // ✅ Update opening checklist status
    updateOpenChecklistStatus: builder.mutation({
      query: ({ data, locationId }) => ({
        url: `/user/restaurant/open-checklist`,
        method: "PUT",
        body: {
          ...data,
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: ["openChecklistStatus"],
    }),

    // ✅ Fetch closing checklist status
    fetchCloseChecklistStatus: builder.query({
      query: ({ locationId } = {}) => ({
        url: `/user/restaurant/close-checklist`,
        params: locationId ? { locationId } : {},
      }),
      providesTags: ["closeChecklistStatus"],
    }),

    // ✅ Update closing checklist status
    updateCloseChecklistStatus: builder.mutation({
      query: ({ data, locationId }) => ({
        url: `/user/restaurant/close-checklist`,
        method: "PUT",
        body: {
          ...data,
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: ["closeChecklistStatus"],
    }),

    // ✅ Fetch hothold checklist status
    fetchHotholdChecklistStatus: builder.query({
      query: ({ locationId } = {}) => ({
        url: `/user/restaurant/hothold-checklist`,
        params: locationId ? { locationId } : {},
      }),
      providesTags: ["hotholdChecklistStatus"],
    }),

    // ✅ Update hothold checklist status
    updateHotholdChecklistStatus: builder.mutation({
      query: ({ data, locationId }) => ({
        url: `/user/restaurant/hothold-checklist`,
        method: "PUT",
        body: {
          ...data,
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: ["hotholdChecklistStatus"],
    }),

    // ✅ Fetch weekly checklist status
    fetchWeeklyChecklistStatus: builder.query({
      query: ({ locationId } = {}) => ({
        url: `/user/restaurant/weekly-checklist`,
        params: locationId ? { locationId } : {},
      }),
      providesTags: ["weeklyChecklistStatus"],
    }),

    // ✅ Update weekly checklist status
    updateWeeklyChecklistStatus: builder.mutation({
      query: ({ data, locationId }) => ({
        url: `/user/restaurant/weekly-checklist`,
        method: "PUT",
        body: {
          ...data,
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: ["weeklyChecklistStatus"],
    }),
  }),
});

export const {
  useFetchChecklistQuery,
  useFetchChecklistsQuery,
  useCreateChecklistMutation,
  useUpdateChecklistMutation,
  useFetchChecklistsByTypeQuery,
  useDeleteChecklistMutation,
  useUpdateChecklistlogMutation,
  useReorderTasksMutation,
  useFetchOpenChecklistStatusQuery,
  useUpdateOpenChecklistStatusMutation,
  useFetchCloseChecklistStatusQuery,
  useUpdateCloseChecklistStatusMutation,
  useFetchHotholdChecklistStatusQuery,
  useUpdateHotholdChecklistStatusMutation,
  useFetchWeeklyChecklistStatusQuery,
  useUpdateWeeklyChecklistStatusMutation,
} = checkListsApi;